import { RefObject, useEffect } from 'react';

type UseDropdownClickOutsideParams = {
  panelRef: RefObject<HTMLElement>;
  active: boolean;
  onClickOutside: () => void;
};

export function useDropdownClickOutside({
  panelRef,
  active,
  onClickOutside,
}: UseDropdownClickOutsideParams) {
  useEffect(() => {
    if (!active) return;

    const handlePointerDown = (event: PointerEvent) => {
      const dropdown = panelRef.current?.closest('.dropdown');
      if (dropdown && !dropdown.contains(event.target as Node)) {
        onClickOutside();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [active, panelRef, onClickOutside]);
}
